import { defineComponent } from "vue";
import type { IDataFooterProps } from "./types";
import { Grid } from "components/grid";
import Pagination from "components/pagination";
import { tv } from "tailwind-variants";
import { useResponsive } from "~/composables/useResponsive";

const clazz = tv({
  base: "h-auto p-4 px-4",
  variants: {
    color: {
      gray: 'bg-gray-50'
    }
  }
})

export const DataFooter = defineComponent<IDataFooterProps>((props) => {
  const responsive = useResponsive();

  const bodyContent = computed(() => {
    const Content = unref(props.body);
    if (!Content) return null;
    if (typeof Content === 'function') return <Content/>;
    return Content;
  })
  
  return () => {
    return (
      <Grid
        alignItems="center"
        class={clazz({ color: props.variant as any })}
        style={{ 
          width: '100%',
          boxShadow: `rgba(0, 0, 0, 0.10) 0px 0px 4px`,
          ...(responsive.isSmall.value ? {
            flex: 'none'
          } : {
            position: 'sticky',
            bottom: '0px',
            left: '0px',
          })
        }}
      >
        {props.pagination && (
          <Pagination noPadding {...props.pagination} variant={props.variant} />
        )}
        {
          bodyContent.value
        }
      </Grid>
    );
  }
}, { props: ['pagination', 'variant', 'body'] })
